import { useState } from 'react';

import VisibilityIcon from '@mui/icons-material/Visibility';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button as MuiButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  Grid,
} from '@mui/material';
import { Button, Labeled } from 'react-admin';
import { useWatch } from 'react-hook-form';
import { SubscriptionAgreementFieldList } from 'src/constants';
import { OfferDocumentTypeDto } from 'src/dtos';

export const SubscriptionAgreementShowFieldsButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const selectedDocumentType = useWatch({
    name: 'type',
  });

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  if (selectedDocumentType !== OfferDocumentTypeDto.SUBSCRIPTION_AGREEMENT) {
    return null;
  }

  return (
    <>
      <Grid item md={12}>
        <Labeled label='Form Fields'>
          <Button label='Show' onClick={handleOpen} startIcon={<VisibilityIcon />} size='medium' />
        </Labeled>
      </Grid>
      <Dialog open={isOpen} onClose={handleClose} maxWidth='lg' fullWidth>
        <DialogTitle>Subscription Agreement Pre-defined Form Fields</DialogTitle>
        <DialogContent>
          <Box sx={{ mb: 2 }}>
            <Typography variant='body2' color='text.secondary'>
              The following fields are required in the Subscription Agreement PDF form:
            </Typography>
          </Box>
          <TableContainer component={Paper} variant='outlined'>
            <Table size='small'>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <strong>Field Name</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Field Type</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Description</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {SubscriptionAgreementFieldList.map(field => (
                  <TableRow key={field.name} hover>
                    <TableCell>{field.name}</TableCell>
                    <TableCell sx={{ textTransform: 'capitalize' }}>{field.type}</TableCell>
                    <TableCell>{field.description}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Box sx={{ mt: 2 }}>
            <Typography variant='caption' color='text.secondary'>
              Total fields: {SubscriptionAgreementFieldList.length}
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <MuiButton onClick={handleClose} color='primary'>
            Close
          </MuiButton>
        </DialogActions>
      </Dialog>
    </>
  );
};
